import React, { useRef, useState } from 'react';
import { ReactComponent as JoyHeartIconSvg } from '@images/joy-heart.svg';
import { styled } from '@styledComponents';
import { Text } from '@components/typography';
import { themeColor } from '@utils/styledTheme.util';
import { animationTransition } from '@utils/animationTransition';

const MobileAccordionHeader = styled.div<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  > svg {
    color: ${({ isActive }) => themeColor(isActive ? 'yellow5' : 'neutra6')};
    opacity: ${({ isActive }) => (isActive ? 1 : 0.5)};
    transition: ${animationTransition('transform')};
    transform: ${({ isActive }) => (isActive ? 'rotate(-180deg)' : 'none')};
  }
`;

const MobileAccordionContent = styled.div<{ isActive: boolean }>`
  padding-top: ${({ isActive }) => (isActive ? '30px' : 0)};
  padding-bottom: ${({ isActive }) => (isActive ? '30px' : 0)};
  height: ${({ isActive }) => (isActive ? 'fit-content' : 0)};
  overflow: hidden;
  transform-origin: top;
  transition: ${animationTransition('height')};
`;

interface Props {
  headerText: string;
  style?: React.CSSProperties;
}

const MobileAccordion: React.FC<Props> = ({ headerText, style, children }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const contentElRef = useRef<HTMLDivElement>(null);

  return (
    <div style={style}>
      <MobileAccordionHeader isActive={!isCollapsed} onClick={() => setIsCollapsed(!isCollapsed)}>
        <Text variant="navParent15" tagName="span" color={!isCollapsed ? 'yellow5' : 'neutra6'}>
          {headerText}
        </Text>
        <JoyHeartIconSvg />
      </MobileAccordionHeader>
      <MobileAccordionContent isActive={!isCollapsed} ref={contentElRef}>
        {children}
      </MobileAccordionContent>
    </div>
  );
};

export default MobileAccordion;
